import Vue from 'vue'
import 'alpinejs'

import VTooltip from 'v-tooltip'

Vue.component('response-time', require('./components/StatusPage/ResponseTime.vue').default)

Vue.use(VTooltip)

new Vue({ el: '#statuspage' })
